import CreateGroupType from "../../../../contents/docs/getting-started/_snippets/group-type-create.mdx";
import ChatGroupType from "../../../../contents/docs/getting-started/_snippets/group-type-create-chat.mdx";
import SetGroupProperties from "../../../../contents/docs/getting-started/_snippets/set-group-properties.mdx";
import * as React from 'react';
export default {
  CreateGroupType,
  ChatGroupType,
  SetGroupProperties,
  React
};